import React from 'react';
import ReactDOM from 'react-dom';
import { DiscountSignupModal } from './DiscountSignupModal';

// Mount discount signup modal once in the header
const renderDiscountSignupModal = () => {
  const mountNode = document.querySelector('[react-render-target="DiscountSignupModal"]');
  if (mountNode) ReactDOM.render(<DiscountSignupModal />, mountNode);
  else console.warn('missing render target: DiscountSignupModal');
};

export const initDiscountSignupModal = () => {
  renderDiscountSignupModal();
};
